"use strict";

import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import {  IconGlyphicon,  IconFontAwesome  } from 'generics/icons';
import ApplicationEvents from 'components/applicationEvents';


const EmailVerificationStateIcon = ({ creds })  =>  {
    const {  haveEmailVerification,  needEmailVerification,  } = creds;

    const  visual = haveEmailVerification ?
                        "success" : (needEmailVerification ? "danger" : "warning");
    return <IconFontAwesome type="envelope" fixedWidth
                mixClasses={[ `text-${visual}` ]}
                title={_I_(`EmailVerificationStateIcon.${visual}`)} />;
}


const TwoFactorStateIcon = ({ creds })  =>  {
    const {  have2step,  need2step,  } = creds;

    const  visual = have2step ? "success" : (need2step ? "danger" : "warning");

    return <IconFontAwesome type="shield" fixedWidth
                mixClasses={[ `text-${visual}` ]}
                title={_I_(`TwoFactorStateIcon.${visual}`)} />;
}


export const CredentialsIcon = ({ creds })  =>  {
    creds = creds||{};
    return (
        <div className="credentials-icon"  >
          <IconFontAwesome type="user-circle" />
          &nbsp;{creds.nick || `User #[ ${creds.userId} ]`}
          &nbsp;<EmailVerificationStateIcon creds={creds} />
          &nbsp;<TwoFactorStateIcon creds={creds} />
        </div>
      );
}


const LimitedAccountPanelHandleRelogin = ()  =>  ApplicationEvents.emit_async("auth.goToRelogin", "LimitedAccountPanelHandleRelogin");


const WarnLimitedDueTwoStep = ({creds})  =>  {
  return  <li>
            <div><TwoFactorStateIcon creds={creds} />&nbsp;
                {_I_("LimitedAccountPanel.2step.reason")}</div>
            <div><a href={_I_("LimitedAccountPanel.2step.href")}>&nbsp;
                {_I_("LimitedAccountPanel.2step.link")}
            </a></div>
          </li>;
}


const WarnLimitedDueEmailVerification = ({creds, steamArgs})  =>  {
  const href = `${_I_("LimitedAccountPanel.email.href")}${steamArgs}`;
  return  <li>
            <div><EmailVerificationStateIcon creds={creds} />&nbsp;
                {_I_("LimitedAccountPanel.email.reason")}</div>
            <div><a href={href}>
                {_I_("LimitedAccountPanel.email.link")}
            </a></div>
          </li>;
}


export const LimitedAccountPanel = ({ creds })  =>  {
    creds = (creds || {});
    const { steamAppId, steamId } = creds;
    const steamArgs = (steamAppId && steamId) ? `?app_id=${steamAppId}&steam_id=${steamId}` : "";

    const limitedDueTwoStep = !!(creds.need2step && (!creds.have2step));
    const limitedDueEmailVerification = !!(creds.needEmailVerification && (!creds.haveEmailVerification));

    if ( !(limitedDueTwoStep || limitedDueEmailVerification) )  {
      return null;
    }

    return (<div className="alert alert-warning">
              <IconGlyphicon type="warning-sign"/>&nbsp;{_I_("LimitedAccountPanel.title")}
              <ul>
                {limitedDueTwoStep && (
                    <WarnLimitedDueTwoStep creds={creds} />
                  )}
                {limitedDueEmailVerification && (
                    <WarnLimitedDueEmailVerification creds={creds} steamArgs={steamArgs} />
                  )}
                <li>
                  <div>{_I_("LimitedAccountPanel.conclusion")}</div>
                  <div><a onClick={LimitedAccountPanelHandleRelogin}>{_I_("LimitedAccountPanel.relogin")}</a></div>
                </li>
              </ul>
            </div>);
}


defineSimpleTerm( "LimitedAccountPanel.2step.reason",  "You need to configure two-factor authorization",       {
    "ru_RU": "Необходимо настроить двухэтапную авторизацию",
    "cs_CZ": "You need to configure two-factor authorization",
    "fr_FR": "Vous devez configurer l'authentification en deux étapes",
    "de_DE": "Du musst die Zwei-Faktor-Authentifizierung aktivieren",
    "it_IT": "Devi configurare l'autorizzazione in due fattori",
    "ko_KR": "이중 보안 절차가 필요합니다",
    "pl_PL": "Musisz skonfigurować dwuetapową autoryzację",
    "pt_PT": "You need to configure two-factor authorization",
    "es_ES": "Necesitas configurar la autorización de dos factores",
    "zh_CN": "你需要设置双重验证",
    "zh_TW": "你需要設置雙重驗證"
} );


defineSimpleTerm( "LimitedAccountPanel.2step.link",  "More about two-factor authorization",       {
    "ru_RU": "Подробнее о двухэтапной авторизации",
    "cs_CZ": "More about two-factor authorization",
    "fr_FR": "Plus d'infos concernant l'authentification en deux étapes",
    "de_DE": "Mehr über die Zwei-Faktor-Authentifizierung",
    "it_IT": "Più informazioni riguardo l'autorizzazione in due fattori",
    "ko_KR": "이중 보안 절차에 대하여 알아보기",
    "pl_PL": "Więcej o dwuetapowej autoryzacji",
    "pt_PT": "More about two-factor authorization",
    "es_ES": "Más información sobre la autorización de dos factores",
    "zh_CN": "有关双重验证的更多信息",
    "zh_TW": "有關雙重驗證的更多信息"
} );


defineSimpleTerm( "LimitedAccountPanel.2step.href",  "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",       {
    "ru_RU": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "cs_CZ": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "fr_FR": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "de_DE": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "it_IT": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "ko_KR": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "pl_PL": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "pt_PT": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "es_ES": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "zh_CN": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "zh_TW": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83"
} );


defineSimpleTerm( "LimitedAccountPanel.email.reason",  "You need to confirm your email address",       {
    "ru_RU": "Необходимо подтвердить ваш email",
    "cs_CZ": "You need to confirm your email address",
    "fr_FR": "Vous devez confirmer votre adresse email",
    "de_DE": "Du musst deine Emailadresse bestätigen",
    "it_IT": "Devi confermare il tuo indirizzo email",
    "ko_KR": "이메일 계정의 본인 확인을 진행하여 주십시오",
    "pl_PL": "Musisz potwierdzić swój adres email",
    "pt_PT": "You need to confirm your email address",
    "es_ES": "Necesitas confirmar tu dirección de correo electrónico",
    "zh_CN": "你需要确认电子邮件地址",
    "zh_TW": "你需要確認電子信箱地址"
} );


defineSimpleTerm( "LimitedAccountPanel.email.link",  "Proceed to profile",       {
    "ru_RU": "Перейти к вашему профилю",
    "cs_CZ": "Proceed to profile",
    "fr_FR": "Complétez le profil",
    "de_DE": "Zum Profil fortfahren",
    "it_IT": "Procedi al profilo",
    "ko_KR": "프로필로 진행하기",
    "pl_PL": "Przejdź do profilu",
    "pt_PT": "Proceed to profile",
    "es_ES": "Proceder al perfil",
    "zh_CN": "前往档案",
    "zh_TW": "前往檔案"
} );


defineSimpleTerm( "LimitedAccountPanel.email.href",  "https://store.gaijin.net/user.php",       {
    "ru_RU": "https://store.gaijin.net/user.php",
    "cs_CZ": "https://store.gaijin.net/user.php",
    "fr_FR": "https://store.gaijin.net/user.php",
    "de_DE": "https://store.gaijin.net/user.php",
    "it_IT": "https://store.gaijin.net/user.php",
    "ko_KR": "https://store.gaijin.net/user.php",
    "pl_PL": "https://store.gaijin.net/user.php",
    "pt_PT": "https://store.gaijin.net/user.php",
    "es_ES": "https://store.gaijin.net/user.php",
    "zh_CN": "https://store.gaijin.net/user.php",
    "zh_TW": "https://store.gaijin.net/user.php"
} );


defineSimpleTerm( "LimitedAccountPanel.title",  "Your account is limited due to:",       {
    "ru_RU": "На аккаунт действуют ограничения по причине:",
    "cs_CZ": "Your account is limited due to:",
    "fr_FR": "Votre compte est limité en raison de:",
    "de_DE": "Dein Konto ist eingeschränkt wegen:",
    "it_IT": "Il tuo account è limitato a causa di:",
    "ko_KR": "계정 기능이 다음 이유로 인해 제한되고 있습니다:",
    "pl_PL": "Twoje konto zostało ograniczone przez:",
    "pt_PT": "Your account is limited due to:",
    "es_ES": "Tu cuenta está limitada debido a:",
    "zh_CN": "你的帐户受到限制，原因为：",
    "zh_TW": "你的帳戶受到限制，原因為："
} );


defineSimpleTerm( "LimitedAccountPanel.conclusion",  "After changing the security settings, you should log out and log in to make the changes take effect",       {
    "ru_RU": "После изменения настроек безопасности необходимо полностью выйти из аккаунта и войти снова чтобы изменения вступили в силу",
    "cs_CZ": "After changing the security settings, you should log out and log in to make the changes take effect",
    "fr_FR": "Après avoir modifié les paramètres de sécurité, vous devez vous déconnecter et vous reconnecter pour que les modifications prennent effet",
    "de_DE": "Nach Änderungen der Sicherheitseinstellungen solltest du dich ausloggen und wieder-einloggen, damit die Änderungen in Kraft treten",
    "it_IT": "Dopo le modifiche alle impostazioni di sicurezza, devi sloggare e riloggare per rendere efficaci i cambiamenti",
    "ko_KR": "계정 보안 설정을 변경하신 후에, 다시 한번 로그인 하셔야 합니다.",
    "pl_PL": "Po zmianie ustawień bezpieczeństwa powinieneś zalogować się ponownie",
    "pt_PT": "After changing the security settings, you should log out and log in to make the changes take effect",
    "es_ES": "Después de cambiar la configuración de seguridad, debes cerrar sesión e iniciar sesión para que los cambios surtan efecto",
    "zh_CN": "更改安全设置后，你应该退出并重新登录以使更改生效",
    "zh_TW": "更改安全設置後，你應該登出並重新登入以使更改生效"
} );


defineSimpleTerm( "LimitedAccountPanel.relogin",  "Relogin...",       {
    "ru_RU": "Сменить аккаунт",
    "cs_CZ": "Relogin...",
    "fr_FR": "Reconnexion...",
    "de_DE": "Re-Login...",
    "it_IT": "Rilogga...",
    "ko_KR": "재접속...",
    "pl_PL": "Zaloguj ponownie...",
    "pt_PT": "Relogin...",
    "es_ES": "Volver a iniciar sesión...",
    "zh_CN": "重新登录…",
    "zh_TW": "重新登入…"
} );


defineSimpleTerm( "EmailVerificationStateIcon.success",  "Confirmed account, email verified",       {
    "ru_RU": "Подтвержденый аккаунт",
    "cs_CZ": "Potvrzený účet, ověřený e-mail",
    "fr_FR": "Compte validé, email vérifié",
    "de_DE": "Konto bestätigt, Email verifiziert",
    "it_IT": "Account confermato, email verificata",
    "ko_KR": "계정 확인됨, 이메일 확인됨",
    "pl_PL": "Konto potwierdzone, email zweryfikowany",
    "pt_PT": "Confirmed account, email verified",
    "es_ES": "Cuenta confirmada, correo electrónico verificado",
    "zh_CN": "帐户已确认，电子邮件已验证",
    "zh_TW": "帳戶已確認，電子信箱已驗證"
} );


defineSimpleTerm( "EmailVerificationStateIcon.warning",  "Unconfirmed account, email not verified",       {
    "ru_RU": "Ограниченый аккаунт, не подтверждена почта",
    "cs_CZ": "Nepotvrzený účet, neověřený e-mail",
    "fr_FR": "Compte non validé, email non vérifié",
    "de_DE": "Konto nicht bestätigt, Email unverifiziert",
    "it_IT": "Account non confermato, email non verificata",
    "ko_KR": "계정 확인 안됨, 이메일 본인 확인 안됨",
    "pl_PL": "Konto niepotwierdzone, email niezweryfikowany",
    "pt_PT": "Unconfirmed account, email not verified",
    "es_ES": "Cuenta no confirmada, correo electrónico no verificado",
    "zh_CN": "帐户未确认，电子邮件未验证",
    "zh_TW": "帳戶未確認，電子信箱未驗證"
} );


defineSimpleTerm( "EmailVerificationStateIcon.danger",  "Unconfirmed account, email verification REQUIRED",       {
    "ru_RU": "Ограниченый аккаунт, НЕОБХОДИМО подтвердить почту",
    "cs_CZ": "Nepotvrzený účet, ověřený e-mail VYŽADOVÁN",
    "fr_FR": "Compte non validé, vérification de l'email OBLIGATOIRE",
    "de_DE": "Konto unbestätigt, Email Verifizierung BENÖTIGT",
    "it_IT": "Account non confermato, verifica email RICHIESTA",
    "ko_KR": "본인 확인이 되지 않은 계정입니다. 이메일 본이 확인이 반드시 필요합니다",
    "pl_PL": "Niepotwierdzone konto, wymagana weryfikacja email",
    "pt_PT": "Unconfirmed account, email verification REQUIRED",
    "es_ES": "Cuenta no confirmada, verificación de correo electrónico REQUERIDA",
    "zh_CN": "帐户未确认，电子邮件需要验证",
    "zh_TW": "帳戶未確認，電子信箱需要驗證"
} );


defineSimpleTerm( "TwoFactorStateIcon.success",  "Account secured with two-factor authorization",       {
    "ru_RU": "Аккаунт защищен двухэтапной авторизацией",
    "cs_CZ": "Účet zabezpečen pomocí dvoufázového ověření",
    "fr_FR": "Compte sécurisé avec l'authentification en deux étapes",
    "de_DE": "Konto mit Zwei-Fakter-Authentifizierung gesichert",
    "it_IT": "Account accertato con l'autorizzazione in due fattori",
    "ko_KR": "계정이 이중 보안으로 보호받고 있습니다",
    "pl_PL": "Konto chronione dzięki dwuetapowej autoryzacji",
    "pt_PT": "Account secured with two-factor authorization",
    "es_ES": "Cuenta asegurada con autorización de dos factores",
    "zh_CN": "帐户已安全进行双重验证",
    "zh_TW": "帳戶已安全進行雙重驗證"
} );


defineSimpleTerm( "TwoFactorStateIcon.warning",  "Insecure account, two-factor authorization disabled",       {
    "ru_RU": "Ограниченый аккаунт, нет двухэтапной авторизации",
    "cs_CZ": "Nezabezpečený účet, dvoufázové ověření vypnuto",
    "fr_FR": "Compte non sécurisé, double authentification désactivée",
    "de_DE": "Ungesichertes Konto, Zwei-Faktor-Authentifizierung abgeschaltet",
    "it_IT": "Account non assicurato, autorizzazione in due fattori disabilitata",
    "ko_KR": "계정이 이중 보안으로 보호받고 있지 않습니다",
    "pl_PL": "Niezabezpieczone konto, autoryzacja dwuetapowa wyłączona",
    "pt_PT": "Insecure account, two-factor authorization disabled",
    "es_ES": "Cuenta insegura, autorización de dos factores deshabilitada",
    "zh_CN": "不安全帐户，双重验证已禁用",
    "zh_TW": "不安全帳戶，雙重驗證已禁用"
} );


defineSimpleTerm( "TwoFactorStateIcon.danger",  "Two-factor authorization REQUIRED",       {
    "ru_RU": "Ограниченый аккаунт, НЕОБХОДИМА двухэтапная авторизация",
    "cs_CZ": "Two-factor authorization REQUIRED",
    "fr_FR": "Double authentification OBLIGATOIRE",
    "de_DE": "Zwei-Faktor-Authentifizierung BENÖTIGT",
    "it_IT": "Autorizzazione in due fattori RICHIESTA",
    "ko_KR": "이중 계정 보안이 반드시 필요합니다",
    "pl_PL": "Autoryzacja dwuetapowa WYMAGANA",
    "pt_PT": "Two-factor authorization REQUIRED",
    "es_ES": "Autorización de dos factores REQUERIDA",
    "zh_CN": "需要双重验证",
    "zh_TW": "需要雙重驗證"
} );

